// extracted by mini-css-extract-plugin
module.exports = {"container":"TAHeader_container__20e4q","logoContainer":"TAHeader_logoContainer__2XMRk"};